module.exports = __webpack_public_path__ + "static/media/sel_08_244.c77df07c.mp4";